import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/api/cruisePorts', request, cancelToken)
}

export {get}
